import { ClientError } from '@ricoh/ria.client.core/errors';
import { createLogger, loggerStyles } from '@ricoh/ria.client.core/plugins/app/logger';

const globalThisCore = globalThis as GlobalThisCore;

const logger = createLogger('app/es');

/**
 * Get nonce value.
 *
 * @returns {string} Nonce value.
 */
export function getNonce(): string {
  const key = '__webpack_nonce__' satisfies keyof GlobalThisCore;
  if (!globalThisCore[key]) {
    const metaCSPNonceEl = document.querySelector<HTMLMetaElement>('meta[property="csp-nonce"]');
    if (!metaCSPNonceEl) {
      throw new ClientError({
        module: 'core',
        message: 'Nonce meta tag not found',
        cause: undefined,
      });
    }

    const value = metaCSPNonceEl.nonce ?? metaCSPNonceEl.getAttribute('content');
    if (!value) {
      throw new ClientError({
        module: 'core',
        message: 'Nonce meta tag value empty',
        cause: undefined,
      });
    }

    globalThisCore[key] = value;
    metaCSPNonceEl.remove();

    logger.writeWithData('info', `${loggerStyles.responseText('Resolve')} CSP Nonce`, globalThisCore[key]);
  }

  return globalThisCore[key];
}

/** Init ES plugin. */
export function initTrustedTypes() {
  if (!globalThisCore.trustedTypes?.createPolicy) {
    return;
  }

  globalThisCore.trustedTypes.createPolicy('default', {
    createHTML: (input) => input,
    createScriptURL: (input) => input,
    createScript: (input) => input,
  });
}
